import { render, staticRenderFns } from "./ProductReporting.vue?vue&type=template&id=2e4e6836&scoped=true"
import script from "./ProductReporting.vue?vue&type=script&lang=js"
export * from "./ProductReporting.vue?vue&type=script&lang=js"
import style0 from "./ProductReporting.vue?vue&type=style&index=0&id=2e4e6836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4e6836",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VAutocomplete,
  VBtn,
  VCard,
  VCheckbox,
  VDataTable,
  VFlex,
  VIcon,
  VLayout,
  VProgressLinear,
})
